__turbopack_context__.v({
  "card-edit-input-container": "LinkStatusContainer-module-scss-module__U2FkEa__card-edit-input-container",
  "link-chip-container": "LinkStatusContainer-module-scss-module__U2FkEa__link-chip-container",
});
